import { RootState } from '@app/store';
import { bonusExpressApi } from '@features/bonus-express/api/bonusExpressApi';
import { IGetExpressBonusesResponse } from '@features/bonus-express/api/bonusExpressApi.type';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IExpressBonusState {
  data: IGetExpressBonusesResponse[],
  selectedBonusId?: number
}
const initialState: IExpressBonusState = {
  data: [],
};

const bonusExpressSlice = createSlice({
  name: 'bonusExpress',
  initialState,
  reducers: {
    setBonusId: (state, action: PayloadAction<number>) => {
      state.selectedBonusId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(bonusExpressApi.endpoints.getExpressBonuses.matchFulfilled, (state, { payload }) => {
        state.data = payload;
      });
  },
});

export const {
  setBonusId,
} = bonusExpressSlice.actions;

export default bonusExpressSlice.reducer;

export const selectBonusExpress = (state: RootState) => state.bonusExpress.data;
export const selectedBonusId = (state: RootState) => state.bonusExpress.selectedBonusId;
